import adminMiddleware from "@/components/profile/admin/ducks/middleware"
import userMiddleware from "@/components/profile/ducks/middleware"

export default [userMiddleware, adminMiddleware]
